@if (isHelpOn()) {
  <div class="hint">The information assets: each is the information itself, such as a customer order, and the information nodes linked to it are its states. Its owner, classification and system of record are its register. Click on an asset (row) to see its states or the models they are in, and the pencil to change its register.</div>
}
@if (canEdit()) {
  <div class="table-actions">
    <button mat-stroked-button color="accent" (click)="editAsset()" data-testid="asset-table-add">
      <mat-icon>add</mat-icon>Add asset
    </button>
  </div>
}
@if (datasource.data.length === 0) {
  <p>There are no information assets. Add one here, or within a model, and link information nodes to it as its states.</p>
  }@else {
  <div class="table-container">
    <table mat-table [dataSource]="datasource" matSort multiTemplateDataRows (matSortChange)="sortChange($event)" data-testid="asset-table">
      @for (column of columns; track column; let i = $index) {
        <ng-container matColumnDef="{{column}}">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="column === 'icon' || column === 'actions'"> {{headings[i]}} </th>
          <td mat-cell *matCellDef="let element" [class.text]="isText(column)">
            @if (column === 'icon') {
                <app-node-svg [type]="element.type"/>
              }@else if (column === 'actions') {
              @if (canEdit()) {
                <span class="row-actions">
                  <button mat-icon-button matTooltip="Edit the asset and its register" (click)="editAsset(element);$event.stopPropagation()" data-testid="asset-table-edit">
                    <span class="material-symbols-outlined">edit</span>
                  </button>
                  <button mat-icon-button color="warn" matTooltip="Delete the asset" (click)="deleteAsset(element);$event.stopPropagation()">
                    <span class="material-symbols-outlined">delete</span>
                  </button>
                </span>
              }
              }@else if (column === 'name') {
              <span [matTooltip]="element.description">{{element.name}}</span>
              }@else if (isText(column)) {
              @if (element[column]) {<span>{{element[column]}}</span>}@else {<span class="none">–</span>}
              }@else if (column === 'derivedValue') {
              @if (element.derivedValue !== undefined) {<span matTooltip="0 to 100 across the organisation's assets, from how it is used across all its states">{{element.derivedValue}}</span>}@else {<span class="none" matTooltip="Worked out with the insights">–</span>}
              }@else if (column === 'value' || column === 'cost') {
              <span [matTooltip]="fullAmount(column, element[column])">{{amount(column, element[column])}}</span>
              }@else {
              {{(element[column] || 0) | number:'1.0-0'}}
            }
          </td>
        </ng-container>
      }

      <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
      <ng-container matColumnDef="expandedDetail">
        <td mat-cell td *matCellDef="let element" [attr.colspan]="columns.length">
            @if (isExpanded(element)) {
                <div class="example-element-detail-wrapper" [class.example-element-detail-wrapper-expanded]="isExpanded(element)">
                <table mat-table [dataSource]="assetsource">
                @for (infoColumn of detailColumns; track infoColumn; let i = $index) {
                    <ng-container matColumnDef="{{infoColumn}}">
                    <td mat-cell *matCellDef="let info" [class.text]="infoColumn === 'name'">
                        @if (infoColumn === 'icon') {
                        <app-node-svg [type]="info.type"/>
                        }@else if (infoColumn === 'name') {
                        {{info.name}}
                        }@else if (infoColumn === 'numberOfStates') {
                        @if (info.numberOfStates) {<span>{{info.numberOfStates}} {{info.numberOfStates === 1 ? 'state' : 'states'}}</span>}
                        }@else {
                        {{(info[infoColumn] || 0) | number:'1.0-0'}}
                        }
                    </td>
                    </ng-container>
                }
                <tr mat-row [id]="info._key" *matRowDef="let info; columns: detailColumns;" (click)="selectInfo(info)"></tr>
                </table>
            </div>
            }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns; sticky:true"></tr>
      <tr mat-row *matRowDef="let element; columns: columns;"
        class="example-element-row"
        [class.example-expanded-row]="isExpanded(element)"
        (click)="expandAsset(element)" [attr.data-testid]="'asset-table-row-' + element._key">
      </tr>
      <tr mat-row [id]="node._key" *matRowDef="let node; columns: ['expandedDetail']" class="example-detail-row"></tr>
    </table>
  </div>
}
